import React, { useState } from 'react';
import { Page } from '@shopify/polaris';
import ThinkificLogo from 'src/components/ThinkificLogo';
import styleConstants from 'src/styles/constants';
import BannerMessages, { BannerStatus } from '../../components/BannerMessages';
import SessionExpired from '../../components/SessionExpired';
import { useTenantContext } from '../../components/TenantProvider';

const SessionExpiredPage = () => {
  const { onSignIn, queryParams, tenant, session } = useTenantContext();
  const [message, setMessage] = useState({
    title: 'Your session has expired.',
    message:
      'Don’t worry, your courses are safe and sound. Enter your password to log back in to your account.',
    status: BannerStatus.info,
  });

  const onError = (err) => {
    setMessage({
      ...err,
      status: BannerStatus.critical,
    });
  };

  const onSuccess = (sessionRes, tenantRes) => {
    return onSignIn(sessionRes, tenantRes);
  };

  return (
    <Page singleColumn>
      <ThinkificLogo />
      <BannerMessages
        message={message.message}
        status={message.status}
        title={message.title}
      />
      <SessionExpired
        session={session}
        shop={queryParams.shop}
        tenant={tenant}
        onError={onError}
        onSuccess={onSuccess}
      />
      <style jsx>{`
        :global(.Polaris-Page) {
          padding-top: ${styleConstants.spacing.six};
        }
      `}</style>
    </Page>
  );
};

export default SessionExpiredPage;
